import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "klickl-pay-picker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      "is-link": "",
      readonly: "",
      name: "calendar",
      "left-icon": "clock-o",
      label: '',
      placeholder: _ctx.placeholder,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.value = $event)),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSheet = true))
    }, null, 8, ["placeholder", "modelValue"]),
    _createVNode(_component_van_action_sheet, {
      show: _ctx.showSheet,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSheet = $event)),
      title: _ctx.$t('cashier.datetime')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          "confirm-button-text": _ctx.$t('complete'),
          "cancel-button-text": _ctx.$t('cancel'),
          "columns-order": ['month', 'year'],
          "min-date": _ctx.minData,
          type: "year-month",
          onCancel: _ctx.clear,
          onConfirm: _ctx.onDateTimePickerHandler
        }, null, 8, ["confirm-button-text", "cancel-button-text", "min-date", "onCancel", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ]))
}